import { useHasPermission } from "@dexteel/mesf-core";
import type { ReactElement } from "react";
import { Navigate } from "react-router-dom";

interface PermissionRouteProps {
	permission: string;
	children: ReactElement;
}

export const PermissionRoute = ({
	permission,
	children,
}: PermissionRouteProps) => {
	const hasPermissionTo = useHasPermission();

	return hasPermissionTo(permission) ? children : <Navigate to="/" replace />;
};
